import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let LoadMap = class LoadMap extends Vue {
    clickMap() {
        this.$emit('click-btn');
    }
};
LoadMap = __decorate([
    Component({
        name: 'LoadMap',
        components: {},
        i18n: {
            messages: {
                zh: {
                    loadMap: '加载地图',
                },
                en: {
                    loadMap: 'Load Map',
                },
            },
        },
    })
], LoadMap);
export default LoadMap;
